<section class="hero">
  <div class="hero__content">
    <div class="hero__banner">
      <h1 class="hero__title">{{ "Doing business in the AIFC" | translate }}</h1>
      <p class="hero__subtitle">
        {{
          "Explore endless opportunities for local and international businesses with unique benefits offered at the AIFC"
            | translate
        }}
      </p>
    </div>
  </div>
</section>
